import { PricingPortalAPI } from "../../apis/pricing-api";
import { AppUtility } from "../../utils/utility";

const ValidationMessage = {
  VALID_EMAIL: "Please enter a valid email address",
  RECORD_EXIST: "Sales user record already exist",
};

const isFormSubmitDisable = (formdata, errordata) => {
  try {
    let _enableSubmit = Object.values(errordata).every((x) => x === null || x === "");
    Object.entries(formdata).forEach(([key, objProps]) => {
      if (objProps.required) {
        _enableSubmit = _enableSubmit && !!objProps.value;
      }
    });

    return !_enableSubmit;
  } catch (err) {
    alert(err);
  }
};

const validateSalesUserRecordExists = async (emailToValidate, businessCode, countryCode) => {
  try {
    const _list = await PricingPortalAPI.getList(businessCode, countryCode, "getAuthSignConfig", "authorisedsignatureuserconfig");
    let _res = [];
    if (_list.length > 0) {
      _res = _list.filter((item) => item.SalesUser === emailToValidate);
    }
    return _res.length > 0;
  } catch (err) {
    alert(err);
    return false;
  }
};

const validateSalesUser = async (e, formStateData, setFormStateData, spinner, businessCode, countryCode) => {
  try {
    if (e?.relatedTarget?.id !== "cancel") {
      if (!formStateData.formError.SalesUser) {
        if (!AppUtility.validateEmail(e.target.value)) {
          setFormStateData((prevData) => ({
            ...prevData,
            formError: { ...formStateData.formError, SalesUser: ValidationMessage.VALID_EMAIL },
            disableFormSubmit: isFormSubmitDisable(formStateData.formData, {
              ...formStateData.formError,
              SalesUser: ValidationMessage.VALID_EMAIL,
            }),
          }));
        } else {
          spinner.setLoadingIndicator(true);
          if (await validateSalesUserRecordExists(e.target.value, businessCode, countryCode)) {
            setFormStateData((prevData) => ({
              ...prevData,
              formError: { ...formStateData.formError, SalesUser: ValidationMessage.RECORD_EXIST },
              disableFormSubmit: isFormSubmitDisable(formStateData.formData, {
                ...formStateData.formError,
                SalesUser: ValidationMessage.VALID_EMAIL,
              }),
            }));
          }
          spinner.setLoadingIndicator(false);
        }
      }
    }
  } catch (err) {
    spinner.setLoadingIndicator(false);
    alert(err);
  }
};

const validateEmailInput = async (e, formStateData, setFormStateData, spinner) => {
  try {
    if (e?.relatedTarget?.id !== "cancel") {
      if (!formStateData.formError[e.target.id]) {
        if (!AppUtility.validateEmail(e.target.value)) {
          let _error = {};
          _error[e.target.id] = ValidationMessage.VALID_EMAIL;
          setFormStateData((prevData) => ({
            ...prevData,
            formError: { ...formStateData.formError, ..._error },
            disableFormSubmit: isFormSubmitDisable(formStateData.formData, { ...formStateData.formError, ..._error }),
          }));
        }
      }
    }
  } catch (err) {
    spinner.setLoadingIndicator(false);
    alert(err);
  }
};

const validateInput = async (e, formStateData, setFormStateData, spinner, businessCode, countryCode) => {
  try {
    switch (e.target.id) {
      case "SalesUser":
        await validateSalesUser(e, formStateData, setFormStateData, spinner, businessCode, countryCode);
        break;
      default:
        await validateEmailInput(e, formStateData, setFormStateData, spinner);
        break;
    }
  } catch (err) {
    spinner.setLoadingIndicator(false);
    alert(err);
  }
};

export { validateInput, validateSalesUserRecordExists, isFormSubmitDisable };
